__turbopack_context__.v({
  "buttonLabel": "ButtonWithLabel-module-scss-module__jNMi0W__buttonLabel",
  "showLabel": "ButtonWithLabel-module-scss-module__jNMi0W__showLabel",
});
